var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.$route.meta && _vm.$route.meta.navSide)?_c('navbar'):_vm._e(),(_vm.$route.meta && _vm.$route.meta.navSide)?_c('sidebar'):_vm._e(),_c('v-main',{staticClass:"bgColor transition-all duration-500 ease-in-out",class:_vm.$route.meta &&
      _vm.$route.meta.navSide &&
      _vm.$store.state.drawerAll.mini &&
      _vm.$store.state.drawerAll.view
        ? 'miniSide-padding'
        : _vm.$route.meta && _vm.$route.meta.navSide && _vm.$store.state.drawerAll.view
        ? 'sidebar-space'
        : ''},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }